import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'

import StackNLoadStars from './StackNLoadStars'

interface Props {
  levelNo: number
  locked?: boolean
  stars: number
  score: number
}

export default function StackNLoadLevel({ levelNo, locked, stars, score }: Props): React.ReactElement {
  const { t } = useTranslation(['games', 'statistics'])

  return (
    <div className={`flex items-center h-12 ${!locked ? 'justify-between' : ''}`}>
      <p>
        {t('statistics:level')} {levelNo}
      </p>
      {!locked ? (
        <>
          <StackNLoadStars stars={stars} />
          <div className="flex font-medium">
            <p>{t('statistics:statistics')}</p>
            <p className="w-16 text-right">{score}</p>
          </div>
        </>
      ) : (
        <SVGImage alt={t('games:cranegame.lock')} className="ml-4" srcKey="scoreboard/lock.svg" />
      )}
    </div>
  )
}
